module.exports = __webpack_public_path__ + "img/wherewevebeen.4a8c2ec1.png";